import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { useState as y } from "react";
import { I as z } from "./ImageCarousel-rVtFRbaH.js";
import { u as p, T as a, I, B as M } from "./useMediaQuery-BZAMobKw.js";
import { S as w } from "./Section-DOeCOW54.js";
import { M as N } from "./Modal-DQnpXu98.js";
const O = "elo-desktop", A = "elo-tablet", D = "elo-mobile", n = {
  "hero-banner": "elo-hero-banner",
  desktop: O,
  "hero-banner__image": "elo-hero-banner__image",
  "hero-banner__tag": "elo-hero-banner__tag",
  "hero-banner__content": "elo-hero-banner__content",
  "hero-banner__content__text": "elo-hero-banner__content__text",
  tablet: A,
  mobile: D,
  "hero-banner__content--remove-text-padding": "elo-hero-banner__content--remove-text-padding",
  "hero-banner__content__buttons": "elo-hero-banner__content__buttons"
}, U = ({
  imageUrl: g,
  statusText: s,
  imageAlt: _,
  title: t,
  isDark: x = !1,
  secondaryTitle: h,
  subtitle: v,
  secondarySubtitle: d,
  primaryButtonText: c,
  secondaryButtonText: l,
  anchorLink: f,
  carouselImages: i,
  ...u
}) => {
  const [C, m] = y(!1), o = p("(min-width: 390px)"), k = `radial-gradient(84.21% 68.63% at 50% 55.23%, rgba(0, 0, 0, 0.75) 0%,rgba(0, 0, 0, 0) 100%), url("${encodeURIComponent(g)}") lightgray 50% / cover no-repeat`, b = p("(max-width: 600px)");
  return /* @__PURE__ */ r(
    w,
    {
      className: n["hero-banner"],
      style: { background: k },
      "aria-label": t,
      ...u,
      ..._ && { title: _ },
      children: [
        /* @__PURE__ */ r("div", { className: n["hero-banner__content"], children: [
          /* @__PURE__ */ r("div", { className: n["hero-banner__content__text"], children: [
            s && /* @__PURE__ */ e(
              a,
              {
                type: "label",
                size: "small",
                extraClass: n["hero-banner__tag"],
                children: s
              }
            ),
            /* @__PURE__ */ r("div", { children: [
              /* @__PURE__ */ e(
                a,
                {
                  extraClass: n["hero-banner__content--remove-text-padding"],
                  type: "heading",
                  size: o ? "large" : "small",
                  children: t
                }
              ),
              h && /* @__PURE__ */ e(
                a,
                {
                  extraClass: n["hero-banner__content--remove-text-padding"],
                  type: "heading",
                  size: o ? "large" : "small",
                  children: h
                }
              )
            ] }),
            /* @__PURE__ */ r("div", { children: [
              /* @__PURE__ */ e(
                a,
                {
                  extraClass: n["hero-banner__content--remove-text-padding"],
                  type: "paragraph",
                  size: o ? "large" : "medium",
                  children: v
                }
              ),
              d && /* @__PURE__ */ e(
                a,
                {
                  extraClass: n["hero-banner__content--remove-text-padding"],
                  type: "paragraph",
                  size: o ? "large" : "medium",
                  children: d
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ r("div", { className: n["hero-banner__content__buttons"], children: [
            /* @__PURE__ */ e(
              I,
              {
                dark: x,
                href: f,
                variant: "primary",
                iconRight: "ArrowDownAlt",
                "aria-label": c,
                small: b,
                children: c
              }
            ),
            l && /* @__PURE__ */ e(
              M,
              {
                variant: "secondary",
                iconRight: "Image",
                onClick: () => m(!0),
                "aria-label": l,
                small: b,
                children: l
              }
            )
          ] })
        ] }),
        i && i.length > 0 && /* @__PURE__ */ e(
          N,
          {
            modalAriaTitle: t + " Image Carousel",
            modalAriaDescription: "Image carousel for the hero banner",
            isOpen: C,
            onClose: () => m(!1),
            size: "lightbox",
            children: /* @__PURE__ */ e(z, { images: i })
          }
        )
      ]
    }
  );
};
export {
  U as H
};
